<template>
      <div class="update">截止{{lastUpdateTime}}，共{{total}}条数据</div>
</template>
<script>
import moment from 'moment'
export default {
    props:{
        updateTime:{
            default:()=>new Date()
        },
        total:{
            type:Number,
            default:0
        }
    },
    computed:{
        lastUpdateTime(){
            return moment(this.updateTime || new Date()).format("YYYY-MM-DD")
        }
    }
}
</script>
<style lang="less" scoped>
.update{
    width: 100%;
    height:34px;
    background:rgba(244,244,244,1);
    padding-left:16px;
    line-height:34px;
    color:rgba(153,153,153,1);

}
</style>